import { Classification, GenericObject, copyFields } from '@synergy/models';

import { Account } from './account';
import { Supplier } from './supplier';

export class Customer extends Account {
    public blacklistedSuppliers?: Supplier[];
    public classifications?: Classification[];

    public static fromPlainObject(object: GenericObject): Customer {
        const customer = new Customer();

        // Import own keys
        copyFields(object, customer);

        // Import from base class (Account)
        const account = Account.fromPlainObject(object);

        // Overwrite own keys with base keys
        copyFields(account, customer);

        if (object['blacklistedSuppliers']) {
            customer.blacklistedSuppliers = object['blacklistedSuppliers'].map(Supplier.fromPlainObject);
        }

        return customer;
    }
}
